import { type ServiceMethod } from '@/application/interfaces/service';

export type Params = {
  cartId: string;
};

export type DiscountTypes =
  | 'promo'
  | 'loyaltyProgram'
  | 'employee'
  | 'payment-method'
  | 'stampedPrice'
  | 'specialPrice'
  | 'twoPrices'
  | 'lys';

export type CartSummaryData = {
  serviceTotal: number;
  discount: number;
  freight: number;
  totalDiscountsByType: Record<DiscountTypes, number>;
  subTotal: number;
  total: {
    inCash: number;
    inInstallments: {
      maxQuantity: number;
      intallmentValue: number;
      totalValue: number;
    };
  };
};

export type Response = {
  data: CartSummaryData;
};

export type QueryParams = {
  payment_method: string;
  simulate: string;
  algo: string[];
};

const getCartSummary: ServiceMethod<Response, Params> =
  (httpClient) => async (data, options) => {
    const { cartId } = data;

    const { body: response } = await httpClient.get<
      Response,
      Params,
      QueryParams
    >('/api/v3/carts/{cartId}/summary', {
      ...options,
      searchParams: {
        payment_method: 'credit_card',
        simulate: 'true',
        algo: ['default', 'discounts'],
      },
      params: {
        cartId,
      },
    });

    return response;
  };

export default getCartSummary;
